// extracted by mini-css-extract-plugin
export default {"myTabs":"tabs_myTabs__3nUvt","badge":"tabs_badge__VVjLP","badge-yellow":"tabs_badge-yellow__o5PzS","badge-green":"tabs_badge-green__8NSln","badge-red":"tabs_badge-red__Bpz-v"};